<template>
  <form-component>
    <form
      novalidate="novalidate"
      @submit.prevent="doSave"
    >
      <p>
        Please select when you would like to be notified
      </p>

      <ul class="criteria-list no-right">
        <li>
          <input
            
            id="send_emails"
            v-model="send_emails"
            name="send_emails"
            class="custom-styled-checkbox"
            type="checkbox"
          >
          <label for="send_emails">
            <span>
              Receive emails from Virginia
            </span>
          </label>
        </li>
        <li>
          <input
            id="email_on_note_tag"
            v-model="email_on_note_tag"
            :disabled="!send_emails"
            name="email_on_note_tag"
            class="custom-styled-checkbox"
            type="checkbox"
          >
          <label for="email_on_note_tag">
            <span>
              Receive an email when tagged in a note
            </span>
          </label>
        </li>
        <li>
          <input
            id="email_active_search_started"
            v-model="email_active_search_started"
            :disabled="!send_emails"
            name="email_active_search_started"
            class="custom-styled-checkbox"
            type="checkbox"
          >
          <label for="email_active_search_started">
            <span>
              Receive an email when an active search starts
            </span>
          </label>
        </li>
      </ul>

      <hr
        v-if="showSaveButton"
        class="hidden-modal"
      >

      <button
        v-if="showSaveButton"
        type="submit"
        class="btn btn-primary submit-btn"
      >
        <processing-text :prc="saving">
          Save Changes
        </processing-text>
      </button>
    </form>
  </form-component>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import ProcessingText from '@/components/ProcessingText.vue';
import UserClient from '@/api/UserClient';

export default {
  name: 'UserSettingsForm',
  components: {
    FormComponent,
    ProcessingText,
  },
  props: {
    onSave: {
      type: Function,
    },
    showSaveButton: {
      type: Boolean,
      default: true,
    },
    settings: {
      type: Object,
    },
  },
  data() {
    return {
      saving: false,
      userClient: new UserClient(this.$http),

      send_emails: true,
      email_on_note_tag: true,
      email_active_search_started: true,
    };
  },
  computed: {
    
  },
  mounted() {
    this.send_emails = this.settings.send_emails;
    this.email_on_note_tag = this.settings.email_on_note_tag;
    this.email_active_search_started = this.settings.email_active_search_started;
  },
  methods: {
    reset() {
      this.saving = false;

      this.send_emails = true;
      this.email_on_note_tag = true;
      this.email_active_search_started = true;
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.errors.clear();

          this.saving = true;

          const {
            send_emails,
            email_on_note_tag,
            email_active_search_started,
          } = this;


          const data = {
            send_emails,
            email_on_note_tag,
            email_active_search_started,
          };

          this.userClient.setNotificationSettings(data).then(res => {
            this.saving = false;
            this.onSave(res);
          }).catch(ex => {
            this.saving = false;
            this.onSave(null, ex);
          });
        } else {
          // for outer save buttons pass back something to stop spinning
          this.$globals.scrollToFirstError(this.$validator);
          this.onSave(null, null);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
h5 {
  span {
    font-weight: normal;
    opacity: 0.4;
    margin-left: 6px;
  }
}

.no-right {
  label {
    padding-right: 15px;
  }
}
</style>
